import { render, staticRenderFns } from "./ClinicalTableRow.vue?vue&type=template&id=b9ac36c4"
import script from "./ClinicalTableRow.vue?vue&type=script&lang=js"
export * from "./ClinicalTableRow.vue?vue&type=script&lang=js"
import style0 from "./ClinicalTableRow.vue?vue&type=style&index=0&id=b9ac36c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports